import React, { useEffect, useState } from "react";
import Header from "../auth/Header";
import { useTranslation } from "react-i18next";
import { Button, message, Upload } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { calculateMega, changeTicketPrice, createOffer18Affiliate, setAdminFunction, startJackpot } from "../web3";
import Offer18Test from "../components/Offer18test";


function Admin({ address, chainId, isConnected, status, open }: any) {
    const { t } = useTranslation();
    const [fileLists, setFileLists] = useState<Record<number, any[]>>({});
    const [number, setNumber] = useState('');
    const [ticketPrice, setTicketPrice] = useState<any>('');
    const [admin, setAdmin] = useState<any>('');
    const [isPasswordTrue, setIsPasswordTrue] = useState(false);
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [affName, setAffName] = useState<any>("");
    const [affLastName, setAffLastName] = useState("");
    const [affIp, setAffIp] = useState("");
    const [affEmail, setAffEmail] = useState("");
    const [affMid, setAffMid] = useState("");
    const [affApi, setAffApi] = useState("");
    const [affSecretKey, setAffSecretKey] = useState("");
    const [offerName, setOfferName] = useState("");
    const [advertiserId, setAdvertiserId] = useState("");
    const [offerUrl, setOfferUrl] = useState("");
    const [offerApi, setOfferApi] = useState("");
    const [offerSecretKey, setOfferSecretKey] = useState("");

    const checkPassword = async (password: string) => {
        try {
            const response = await fetch("https://cryptolottery777.com/public/password/check", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ password }),
            });

            if (!response.ok) {
                throw new Error(`Ошибка: ${response.status}`);
            }

            const result = await response.json();
            console.log("Ответ сервера:", result);
            return result;
        } catch (error) {
            console.error("Ошибка при проверке пароля:", error);
        }
    };

    const changePassword = async (password: string) => {
        try {
            const response = await fetch("https://cryptolottery777.com/public/password", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ password }),
            });

            if (!response.ok) throw new Error(`Ошибка: ${response.status}`);

            const result = await response.json();
            return result;
        } catch (error) {
            console.error("Ошибка при смене пароля:", error);
            message.error("Не удалось сменить пароль");
        }
    };

    const handleChangePassword = async () => {
        if (!newPassword) {
            message.warning("Введите новый пароль");
            return;
        }

        const result = await changePassword(newPassword);
        if (result?.success) {
            message.success("Пароль успешно обновлён");
            setNewPassword("");
        } else {
            message.error("Ошибка при обновлении пароля");
        }
    };


    const handleManualUpload = async (index: number, actionUrl: string) => {
        const fileList = fileLists[index];
        if (!fileList || fileList.length === 0) {
            message.warning("Выберите файл перед загрузкой");
            return;
        }

        const formData = new FormData();
        formData.append("file", fileList[0].originFileObj);

        try {
            const res = await fetch(actionUrl, {
                method: "POST",
                body: formData,
            });

            const text = await res.text(); // полезно для отладки
            console.log("Response text:", text);

            if (res.ok) {
                message.success(`Файл ${fileList[0].name} успешно загружен`);
            } else {
                message.error("Ошибка при загрузке файла");
            }
        } catch (err) {
            message.error("Ошибка сети");
            console.error(err);
        }
    };

    const renderUploader = (index: number, label: string, actionUrl: string) => (
        <div key={index} style={{
            marginBottom: '1rem',
            display: "flex",
            minWidth: '500px',
            width: '100%',
            alignItems: "flex-start",
            gap: '56px'
        }}>
            <Upload
                beforeUpload={() => false} // Отключаем авто-загрузку
                fileList={fileLists[index] || []}
                onChange={({ fileList }) => {
                    const limited = fileList.slice(-1);
                    setFileLists((prev) => ({ ...prev, [index]: limited }));
                }}
                maxCount={1}
            >
                <Button icon={<UploadOutlined />} style={{ width: "250px" }}>{t(`Выбрать ${label}`)}</Button>
            </Upload>
            <Button
                type="primary"
                onClick={() => handleManualUpload(index, actionUrl)}
                disabled={!fileLists[index] || fileLists[index].length === 0}
                rootClassName="upload-btn"
            >
                {t("Загрузить на сервер")}
            </Button>
        </div>
    );

    const handleCalculateMega = () => {
        calculateMega()
    }
    const handleStartNewCycle = () => {
        startJackpot()
    }

    const handleSetAdmin = () => {
        const num = Number(admin);
        setAdminFunction()
    };
    const handleCreateAffilate = () => {
        createOffer18Affiliate({
            first_name: affName,
            last_name: affLastName,
            signup_ip: affIp,
            email: affEmail,
            mid: affMid,
            api_key: affApi,
            secret_key: affSecretKey
        });
    };
    const handleChangeTicketPrice = async () => {
        await changeTicketPrice(ticketPrice * 10 ** 18)
    };

    const handleInputPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };
    const handleLogin = async () => {
        try {
            const result: any = await checkPassword(password);
            console.log("Ответ от сервера:", result);

            if (result?.success) {
                setIsPasswordTrue(true);
            } else {
                message.error("Неверный пароль");
            }
        } catch (err) {
            console.error("Ошибка при логине:", err);
            message.error("Произошла ошибка при проверке пароля");
        }
    };


    return (
        <>
            {isPasswordTrue ? <div style={{ width: '100%' }}>
                <Header
                    address={address}
                    chainId={chainId}
                    isConnected={isConnected}
                    open={open}
                    status={status}
                />

                <div className="admin-web">
                    <div>
                        {[
                            { label: 'Передний баннер 1', url: 'https://cryptolottery777.com/public/image/data/1' },
                            { label: 'Задний баннер 1', url: 'https://cryptolottery777.com/public/image/data/2' },
                            { label: 'Передний баннер 2', url: 'https://cryptolottery777.com/public/image/data/3' },
                            { label: 'Задний баннер 2', url: 'https://cryptolottery777.com/public/image/data/4' },
                            { label: 'Передний баннер 3', url: 'https://cryptolottery777.com/public/image/data/5' },
                            { label: 'Задний баннер 3', url: 'https://cryptolottery777.com/public/image/data/6' },
                            { label: 'Передний баннер 4', url: 'https://cryptolottery777.com/public/image/data/7' },
                            { label: 'Задний баннер 4', url: 'https://cryptolottery777.com/public/image/data/8' },
                        ].map((item, index) => renderUploader(index, item.label, item.url))}
                    </div>

                    <div className="functions-section">
                        <div className="functions-section_btn">
                            <span className="functions-section_btn__label">function name</span>
                            <span className="functions-section_btn__button"
                                onClick={handleCalculateMega}>{t('Отправить')}</span>
                        </div>
                        <div className="functions-section_btn">
                            <span className="functions-section_btn__label">Start New Cycle</span>
                            <span className="functions-section_btn__button"
                                onClick={handleStartNewCycle}>{t('Отправить')}</span>
                        </div>

                        <div className="functions-section_btn-input">
                            <input
                                type="number"
                                className="input-number"
                                placeholder="введите число"
                                value={ticketPrice}
                                onChange={(e) => setTicketPrice(e.target.value)}
                            />
                            <div className="functions-section_btn">
                                <span className="functions-section_btn__label">Set Ticket Price</span>
                                <span className="functions-section_btn__button"
                                    onClick={handleChangeTicketPrice}>{t('Отправить')}</span>
                            </div>
                        </div>
                        <div className="functions-section_btn-input">
                            <input
                                type="number"
                                className="input-number"
                                placeholder="введите адрес (admin)"
                                value={admin}
                                onChange={(e) => setAdmin(e.target.value)}
                            />
                            <div className="functions-section_btn">
                                <span className="functions-section_btn__label">Set Admin Status</span>
                                <span className="functions-section_btn__button"
                                    onClick={handleSetAdmin}>{t('Отправить')}</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="change-password">

                    <div className="offer_block">
                        <div className="functions-section_btn-input">
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите имя"
                                value={affName}
                                onChange={(e) => setAffName(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите фамилия "
                                value={affLastName}
                                onChange={(e) => setAffLastName(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите ip"
                                value={affIp}
                                onChange={(e) => setAffIp(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите эл.адрес"
                                value={affEmail}
                                onChange={(e) => setAffEmail(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите mid"
                                value={affMid}
                                onChange={(e) => setAffMid(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите api-key"
                                value={affApi}
                                onChange={(e) => setAffApi(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите secret-key"
                                value={affSecretKey}
                                onChange={(e) => setAffSecretKey(e.target.value)}
                            />
                            <div className="functions-section_btn">
                                <span className="functions-section_btn__label">Создать Affilate</span>
                                <span className="functions-section_btn__button"
                                    onClick={handleCreateAffilate}>{t('Отправить')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="offer_block">
                        <div className="functions-section_btn-input">
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите имя Офера"
                                value={offerName}
                                onChange={(e) => setOfferName(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите advertiser_ID "
                                value={advertiserId}
                                onChange={(e) => setAdvertiserId(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите ссылка Офера"
                                value={offerUrl}
                                onChange={(e) => setOfferUrl(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите mid"
                                value={affMid}
                                onChange={(e) => setAffMid(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите api"
                                value={offerApi}
                                onChange={(e) => setOfferApi(e.target.value)}
                            />
                            <input
                                type="text"
                                className="input-number"
                                placeholder="введите secret-key"
                                value={offerSecretKey}
                                onChange={(e) => setOfferSecretKey(e.target.value)}
                            />

                            <div className="functions-section_btn">
                                <span className="functions-section_btn__label">Создать Offer</span>
                                <span className="functions-section_btn__button"
                                    onClick={handleCreateAffilate}>{t('Отправить')}</span>
                            </div>
                        </div>
                    </div>
                    <Input.Password
                        placeholder="Новый пароль"
                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        className="login-body-input"
                    />
                    <Button onClick={handleChangePassword} className="login-btn" style={{ width: '150px', marginLeft: '70px' }}>
                        Сменить пароль
                    </Button>
                </div>
            </div> :

                <div className="login-body">
                    <Input.Password
                        placeholder="input password"
                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        onInput={handleInputPassword}
                        className="login-body-input"
                    />
                    <button className="login-btn" onClick={handleLogin}>Login</button>
                </div>

            }
        </>
    );
}

export default Admin;
